<template>
  <form
    data-vv-scope="login"
    @submit.prevent="action('login')"
  >
    <div class="form-group">
      <label
        class="control-label requiredField"
        for="select"
								data-test="vendorLoginVerificationFrmPasswrdOtp"
								id="vendorLoginVerificationFrmPasswrdOtp"
      >
        Password or OTP
        <span class="asteriskField"
														data-test="vendorLoginVerificationFrmPasswrdOtpSpan"
														id="vendorLoginVerificationFrmPasswrdOtpSpan">
          *
        </span>
      </label>
      <select
        class="select form-control"
        id="select"
        name="select"
        v-model="selectedVerification"
        v-validate="'required|included:Password,OTP'"
        :class="(showLoginError &&
                      errors.has('login.select'))?'is-invalid':''"
        @change="optionSelect"
								data-test="vendorLoginVerificationFrmPasswrdOtpSelect"
      >
        <option disabled
																data-test="vendorLoginVerificationFrmPasswrdOtpOptn1"
																id="vendorLoginVerificationFrmPasswrdOtpOptn1">
          Select...
        </option>
        <option value="Password"
																data-test="vendorLoginVerificationFrmPasswrdOtpOptn2"
																id="vendorLoginVerificationFrmPasswrdOtpOptn2">
          Password
        </option>
        <option value="OTP"
																data-test="vendorLoginVerificationFrmPasswrdOtpOptn3"
																id="vendorLoginVerificationFrmPasswrdOtpOptn3">
          OTP
        </option>
      </select>
      <div
        class="invalid-feedback"
        v-if="showLoginError"
        v-show="errors.has('login.select')"
        id="vendor-RegisterForm-hostCountryName-error"
								data-test="vendorLoginVerificationFrmPasswrdOtpError"
      >
        {{errors.first('login.select')}}
      </div>
    </div>

    <div
      class="form-group"
      v-if="selectedVerification === 'Password'"
    >
      <label
        class="control-label "
        for="password"
								data-test="vendorLoginVerificationFrmPasswrd"
								id="vendorLoginVerificationFrmPasswrd"
      >
        Password
      </label>
      <input
        class="form-control"
        id="password"
        name="password"
        type="password"
        v-model="emailAcct.password"
        v-validate="'required'"
        :class="(showLoginError &&
                errors.has('login.password'))?'is-invalid':''"
        autocomplete="off"
								data-test="vendorLoginVerificationFrmPsswrdInput"
      />
      <div
        class="invalid-feedback"
        v-if="showLoginError"
        v-show="errors.has('login.password')"
        id="vendor-RegisterForm-passwrd-error"
								data-test="vendorLoginVerificationFrmPsswrdError"
      >
        {{errors.first('login.password')}}
      </div>
    </div>

    <div
      class="form-group"
      v-if="selectedVerification === 'OTP'"
    >
      <label
        class="control-label "
        for="text"
								data-test="vendorLoginVerificationFrmOtp"
								id="vendorLoginVerificationFrmOtp"
      >
        OTP
      </label>
      <input
        class="form-control"
        id="text"
        name="text"
        type="text"
        v-model="otp"
        maxlength="6"
        :class="(showLoginError &&
                errors.has('login.text'))?'is-invalid':''"
        autocomplete="off"
        @keypress="isNumValid($event)"
        @paste="otpReplace"
								data-test="vendorLoginVerificationFrmOtpInput"
      />
      <!--<div class="invalid-feedback"-->
      <!--v-if="showLoginError"-->
      <!--v-show="errors.has('login.text')"-->
      <!--id="vendor-RegisterForm-otp-error"-->
      <!--&gt;-->
      <!--{{errors.first('login.text')}}-->
      <!--</div>-->
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="action('login')"
								data-test="vendorLoginVerificationFrmBtn"
								id="vendorLoginVerificationFrmBtn"
      >
        Login
      </button>
    </div>
  </form>
</template>

<script>
export default {
	data () {
		return {
			emailAcct: {
				username: '',
				password: ''
			},
			showLoginError: false,
			otp: '',
			selectedVerification: 'Select...'
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						if (this.selectedVerification === 'OTP') {
							this.$emit('vendorVerificationViaOtp', { otp: this.otp })
						}
						if (this.selectedVerification === 'Password') {
							this.$emit('vendorVerificationViaPassword', this.emailAcct)
						}
						this.showLoginError = false
						$('#LoginModal').modal('hide')
					} else {
						this.showLoginError = true
					}
				})
		},
		optionSelect () {
			if (this.selectedVerification === 'OTP') {
				this.$emit('vendorLoginOtpRequest', { email: this.email })
			} else if (this.selectedVerification === 'Password') {
				this.emailAcct.username = this.email
			}
		},
		isNumValid (evt) {
			const charCode = (evt.which) ? evt.which : event.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault()
				return false
			}

			return true
		},
		otpReplace (e) {
			e.preventDefault()
			let pastedText = ''
			if (window.clipboardData && window.clipboardData.getData) {
				pastedText = window.clipboardData.getData('Text')
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedText = e.clipboardData.getData('text/plain')
			}
			this.otp = pastedText.replace(/\D/g, '')
		}
	},
	props: {
		email: null,
		resetFormData: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		resetFormData () {
			if (this.resetFormData === true) {
				this.emailAcct = {
					username: '',
					password: ''
				}
				this.showLoginError = false
				this.otp = ''
				this.selectedVerification = 'Select...'
			}
		}
	}
}
</script>
